<template>
    <div>
        <b-card class="my-4 dark-card" header-class="dark-card-header">
          <template #header>User Debug Information</template>
          <span>
            <CButton type="submit" class="btn-info" @click='startPaywall' :disabled="! onnet" >Start Paywall</CButton>&nbsp;&nbsp;
            <CButton type="submit" class="btn-info" @click='stopPaywall' :disabled="! onnet" >Stop Paywall</CButton>           
          </span>
        </b-card>
        <div v-if="isAuthenticated"> 
        <b-card class="my-4 dark-card" header-class="dark-card-header">
          <template #header>Connection Information</template>
          <span>
            <p> The user is <span v-if="! onnet" >NOT</span> onnet</p> 
            <p> The user is <span v-if="! connected" >NOT</span> connected</p> 
            <CButton type="submit" class="btn-info" @click='checkStatus' :disabled="!onnet" >Check Status</CButton>&nbsp;&nbsp;            
            <CButton type="submit" class="btn-info" @click='connect' :disabled="connected || !onnet" >Connect</CButton>&nbsp;&nbsp;
            <CButton type="submit" class="btn-info" @click='disconnect' :disabled="!connected || !onnet" >Disconnect</CButton>
            <b-button variant="warning" :disabled="!onnet" @click="disconnect">EmergencyDisconnect{{ connected }}</b-button>
            <p v-if="onnet" >CPD Session <span v-if='cpdSession'>{{cpdSession }}</span></p>
          </span>
        </b-card>
        <b-card class="my-4 dark-card" header-class="dark-card-header">
          <template #header>Current Application Details</template>
          <span>
            Application: SoldierNET portalui<br/>
            Current Version: {{version}}<br/>
            Log Level ({{logLevel}}): <select v-model="logLevel" >
              <option v-for="l in levels" :key="l.level" :value='l.level' >
                {{ l.name }} ({{ l.level }})
              </option>
            </select>
          </span>
          <br/>
          <br/>
          Show Stack (Debug/Trace only) <input type="checkbox" v-model="logstack" /><br/>
        </b-card>
        <b-card class="my-4 dark-card" header-class="dark-card-header">
          <template #header>Refresh token</template>
          <span>
            
            Issued: <span >{{ new Date(refreshDetails.iat * 1000) }}</span><br/>
            Expires: <span >{{ new Date(refreshDetails.exp * 1000) }}(<countdown
              :endDate="new Date(refreshDetails.exp * 1000)"
            ></countdown>
            seconds)</span><br/>
            Details: {{ refreshDetails }} <br/>
            Refresh token: {{ refreshToken }} <br/>

          </span>
        </b-card>
        <b-card class="my-4 dark-card" header-class="dark-card-header">
          <template #header>Access token</template>
          <span>  
 
            Issued: <span >{{ new Date(accessDetails.iat * 1000) }}</span><br/>
            Expires: <span >{{ new Date(accessDetails.exp * 1000) }}(<countdown
              :endDate="new Date(accessDetails.exp * 1000)"
            ></countdown>
            seconds)</span><br/>
            Details: {{ accessDetails }} <br/>
            Access token: {{ accessToken }} <br/>

          </span>
        </b-card>
        <b-card class="my-4 dark-card" header-class="dark-card-header">
          <template #header>Worldpay Form Testing</template>
          <form :action="worldpay.baseurl + 'purchase'" method="POST" ref="flex">
            TestMode:<input type="text" name="testMode" :value="0" /><br />
            InstID:<input type="text" name="instId" :value="worldpay.instRef" /><br />
            CartID:<input type="text" name="cartId" value="SoldierNET Broadband" /><br />
            Username:<input type="text" name="M_username" :value="account.username" /><br />
            ProductID:<input
              type="number"
              name="M_productid"
              value="1"
            /><br />
            Action:<input type="text" name="M_ACTION" value="FLEXICREDITS" /><br />
            SiteID:<input type="number" name="M_siteid" :value="site.siteid" /><br />
            <!-- UNNEEDED <input
              v-if="onnet && status != null && status.session != null"
              type="hidden"
              name="M_cpAddress"
              :value="status.session.lease.ip"
            /> -->
            Credits:<input type="number" name="M_credits" value="1" /><br />
            Amount:<input type="number" name="amount" v-model="amount" /><br />
            Currency:<input type="text" name="currency" value="GBP" /><br />
            <input type="hidden" name="hideCurrency" />
            <input type="hidden" name="option" value="0" />
            Redirect:<input type="text" name="M_redirect" value="192.168.0.141" /><br />
            <!-- Signature:<input type="text" name="signature" :value="signature" /><br />
            Signature Fields:<input type='text' name='signatureFields' value='instId:amount:currency' /><br />
            <input type="hidden" name=authValidTo :value="authValidUntil(15)"> -->
            <CButton
              type="submit"
              class="btn-info"
              @click="
                () => {
                  startpaywall(ipAddress, mac);
                }
              "
              >Confirm and Pay for FlexiPlan</CButton
            >
          </form>
        </b-card>
      </div>
        <!-- the last axios request -->
        <!-- the last alert perhaps -->
    </div>
</template>

<script>
import store from '@/store'
import jwt_decode from 'jwt-decode'
import {
  Countdown,  
} from "@/components/general/index";
import { mapGetters, mapActions, mapState } from "vuex";
import { startpaywall, stoppaywall, checkMyStatus } from 'src/cpd'
import { ErrorService } from '../../helpers/errorplugin'
import { connectToInternet, disconnectFromInternet } from 'src/cpd';

export default {
    name: "DebugInfo",
    components: {
      Countdown,
      ErrorService
    },
    data() {
      return {
        isAuthenticated: store.getters['account/isAuthenticated'],
        accessToken: store.getters['account/accessToken'],
        refreshToken: store.getters['account/refreshToken'],
        version: process.env.PACKAGE_VERSION,
        sources: [],
        levels: ErrorService.levels,
        signature: '',
        amount: 1
      }
    },
    watch: {
        amount: {
            immediate: true,
            handler(newVal) {
              this.$portalapi.get("worldpay/prepare", { params: { amount: newVal, currency: "GBP" } }).then((response) => {
                this.signature = response.data;
                this.$log.onDebug("Prepared data for worldpay transaction has been recieved - " + JSON.stringify(response.data));
              },
              (error) => {
                this.$log.onError("Failed to prepare for worldpay transaction due to error - " + JSON.stringify(error))
              })
            },
        },
    },
  // computed: {
  //   ...mapGetters({
  //     products: "pricing/getProducts",
  //     prices: "pricing/getPrices",
  //     flexiPrices: "pricing/getFlexiPrices",
  //     selectedProduct: "pricing/getChosenProduct",
  //     selectedPeriod: "pricing/getChosenPeriod",
  //     special: "pricing/getSpecial",
  //     subscription: "plan/getSubscription",
  //     activeproduct: "plan/getActiveProduct",
  //     activeuntil: "plan/getActiveUntil",
  //     minimumPrice: "pricing/getMinimumPrice",
  //   }),
    computed: {
      ...mapGetters({
        connected: 'captive/isConnected',
        cpdSession: 'captive/cpdSession',
        site: "account/site",
        worldpay: "pricing/getWorldpay",
        account: "account/account"
      }),

      ...mapState('captive', ['onnet', 'status']),

      mac() {
        return this.status?.session?.lease?.ethernet || null;
      },
      ipAddress() {
        return this.status?.session?.lease?.ip || null;
      },

      logstack: {
        get: function () {
          return this.$store.getters["logging/logStack"];
        },
        set: function (newv) {
          this.$store.dispatch("logging/setLogStack", newv);
        },
      },
      logLevel: {
        get: function(){
          return this.$store.getters['logging/logLevel']
        },
        set: function(newv){
          this.$store.dispatch('logging/setLogLevel', newv)
        }
      },
      refreshDetails: function () {
        if (this.refreshToken == '')
          return null
        else 
          return jwt_decode(this.refreshToken);
      },
      accessDetails: function() {
        if (this.accessToken == '')
          return null
        else 
          return jwt_decode(this.accessToken);
      },
      ...mapState('captive', ['onnet'])
      
    },
    methods: {
      ...mapActions({setLogLevel: 'logging/setLogLevel'}),
      checkStatus(){
        if ( this.onnet ) {
          this.$log.onDebug("We are on net")
          let status = checkMyStatus()          
        } else {
          this.$log.onDebug("We are not on net")
        }
        
      },
      startPaywall(){
        if ( this.onnet ) {
          this.$log.onDebug("We are on net")
          let status = checkMyStatus()
          // rd { connected: bool, session: {} }
          if ( ! status.connected ) {
            this.$log.onDebug("...but not currently connected, so enable paywall")
            startpaywall(ipAddress, mac)
          }
        } else {
          this.$log.onDebug("We are not on net")
        }
        
      },
      stopPaywall(){
        if ( this.onnet ) {
          this.$log.onDebug("We are on net")
          stoppaywall()
        } else {
          this.$log.onDebug("We are not on net")
        }
        
      },
      authValidUntil(timeoutMins) {
        // Get the current time
        var now = new Date();

        // Add specified minutes (15 in your case) to the current time
        now.setMinutes(now.getMinutes() + timeoutMins);

        // Return the time as a Unix timestamp
        return Math.floor(now.getTime());
      },
      connect() {
        connectToInternet();
      },
      disconnect() {
        disconnectFromInternet();
      }
    },
    mounted: function() {
    }
}
</script>

<style>

</style>